const UnknownPage = () => {
  return (
    <div>
      <p>Tính năng đang phát triển</p>
    </div>
  );
};

export default UnknownPage;
